import React, { useState } from "react";
import "./Navbar_menu.css";
import { Link, useLocation, useNavigate } from "react-router-dom";     
import { useAuth } from "../auth/AuthContext";
import { maAdminPristup } from "../auth/pristupyPouzivatelov";
import logoLight from "../obr/FCA_App_black2.png";
import logoDark from "../obr/FCA_App_gold2.png";
import userCircleIkona from "../obr/user-circle.svg";
import userCircleIkonaDark from "../obr/user-circle_dm.svg";
import logoutIkona from "../obr/logout.svg";
import logoutIkonaDark from "../obr/logout_dm.svg";


export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const isAdmin = maAdminPristup(user);

   const nacitajTemu = () => {
    const ulozena = localStorage.getItem('tema');
    return ulozena === 'dark' ? 'dark' : 'light';
  };

  const [tema, setTema] = useState(nacitajTemu);

  const aktualneLogo = tema === "light" ? logoLight : logoDark;
  const aktualnaUserIkona = tema === "light" ? userCircleIkona : userCircleIkonaDark;
  const aktualnaLogoutIkona = tema === "light" ? logoutIkona : logoutIkonaDark;

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  const prepniTemu = () => {
    setTema((t) => (t === 'dark' ? 'light' : 'dark'));
  };

  const jeSvetlyRezim = tema === 'light';

  const closeMenu = () => setOpen(false);
  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search, location.hash]);

  return (
    <header className="nav" role="banner">
      <div className="nav__inner">
        <div className="nav__brand" aria-label="FinCloud Advisor App logo">
          <img
            src={aktualneLogo}
            alt="FinCloud"
            className="nav__logo-img"
          />
        </div>

        <button
          className="nav__burger"
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="nav-menu"
          onClick={() => setOpen(!open)}
        >
          <span className="nav__burger-line" />
          <span className="nav__burger-line" />
          <span className="nav__burger-line" />
        </button>

        <nav
          id="nav-menu"
          className={`nav__menu ${open ? "is-open" : ""}`}
          aria-label="Hlavná navigácia"
        >
          {/* sekcie – anchors, kým nemáme routerové stránky */}
          <Link to="/app#kalkulacka" className="nav__link" onClick={closeMenu}>Hypotéky</Link>
          <Link to="/investicie" className="nav__link" onClick={closeMenu}>Investície</Link>

          {isAdmin && (
            <Link
              to="/admin"
              className="nav__cta"
              onClick={closeMenu}
            >
              Admin
            </Link>
          )}

          <span className="nav__spacer" />
           <button
            type="button"
            className={`nav-theme-switch ${jeSvetlyRezim ? 'is-light' : 'is-dark'}`}
            onClick={prepniTemu}
            aria-label={jeSvetlyRezim ? 'Prepnúť na tmavý režim' : 'Prepnúť na svetlý režim'}
            title={jeSvetlyRezim ? 'Prepnúť na tmavý režim' : 'Prepnúť na svetlý režim'}
          >
            <span className="nav-theme-switch__track">
              <span className="nav-theme-switch__text">
                {jeSvetlyRezim ? 'SVETLÝ' : 'TMAVÝ'}
              </span>
              <span className="nav-theme-switch__thumb" aria-hidden="true" />
            </span>
          </button>

          {user ? (
            <>
              <button
                type="button"
                className="nav__link nav__user-action"
                title={user.email}
                onClick={() => {
                  closeMenu();
                  nav("/profil");
                }}
              >
                <img src={aktualnaUserIkona} alt="" className="nav__user-icon" aria-hidden="true" />
                <span>Profil</span>
              </button>

              <button
                type="button"
                className="nav__link nav__logout nav__user-action"
                onClick={async () => {
                  await logout();
                  closeMenu();
                  nav("/login", { replace: true });
                }}
              >
                <img src={aktualnaLogoutIkona} alt="" className="nav__user-icon" aria-hidden="true" />
                <span>Odhlásiť</span>
              </button>
            </>
          ) : (
            <Link to="/login" className="nav__link" onClick={closeMenu}>
              Prihlásiť
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}